/* tslint:disable */
export const ERROR_MESSAGES = {
    SOMETHING_WENT_WRONG: 'Something went wrong, please try again. If the problem occurs again, please contact us.',
    SOMETHING_WENT_WRONG_WITH_LOADING_REGIONS: 'An error occurred while loading the new regions. Please try again.',
    SOMETHING_WENT_WRONG_WITH_SAVING_LINK: 'An error occurred while saving your link description. Please try again.',
    SOMETHING_WENT_WRONG_WITH_DELETING_LINK: 'An error occurred while deleting your link. Please try again.',
    SOMETHING_WENT_WRONG_WITH_LOCATING_ROI: 'Sorry, but we could not locate the ROI file. Please remove this file and try uploading it again.',
    SOMETHING_WENT_WRONG_WITH_MATCHING_PASSWORD: 'Your new password does not match your confirmation password. Please make sure they match.',
    PASSWORD_DOESNOT_MATCH_CONFIRMATION: 'Your password and its confirmation do not match. Please try again.',
    OLD_PASSWORD_WRONG: 'Your old password is wrong. Please try again.',
    NOT_ADMIN: 'You are not an Admin. Only admin users can enter the Admin pages.',
    USERNAME_OR_PASSWORD_WRONG: 'The username or password is wrong. Please try again.',
    ERROR_WHILE_GENERATE_ANATOMICAL_MATRIX: 'An error occurred while generating the anatomical matrix. Please try again.',
    ERROR_WHILE_GENERATE_MASK: 'An error occurred while generating the necessary mask images for drawing. Please try again.',
    ENTER_EMAIL: 'Please enter your email',
    ENTER_USERNAME: 'Please enter your username',
    ENTER_LABNAME: 'Please enter your lab name',
    ENTER_FIRSTNAME: 'Please enter your first name',
    ENTER_LASTNAME: 'Please enter your last name',
    ENTER_PASSWORD: 'Please enter your password',
    ENTER_NEW_PASSWORD: 'Please enter your new password',
    ENTER_OLD_PASSWORD: 'Please enter your old password.',
    ENTER_PASSWORD_CONFIRMATION: 'Please enter your password confirmation',
};

export const WARNING_MESSAGES = {
    DATABASE_LOCKE: 'Due to maintenance work, saving your data is currently not possible. Please try again later. Thank you for your patience!'
};

export const SUCCESS_MESSAGES = {};
